export const uk = {
    'empty-region': 'Не указаны регионы',
    'error-message': 'Произошла непредвиденная ошибка. Повторите попытку позже.',
    'incorrect-region': 'Неправильно указан регион',
    'invalid-client-currency': 'Валюта пакета не соответствует валюте клиента для id: {value}',
    'invalid-client-ids': {
        one: 'Невалидный клиент с id: {value}',
        some: 'Невалидный клиенты с id: {value}',
        many: 'Невалидный клиенты с id: {value}',
        none: 'Невалидный клиент с id: {value}'
    },
    'name-cannot-be-empty': 'Не указано название пакета',
    'name-contain-only-symbols':
        'В заголовке можно использовать только буквы латинского, турецкого, русского, украинского, белорусского или казахского алфавита, цифры и знаки препинания',
    'name-greater-than-max': 'Длина названия должна быть менее {value} символов',
    'package-forbidden-to-change': 'todo',
    'price-greater-then-max': 'Ставка должна быть меньше или равна {value}',
    'price-less-then-min': 'Ставка должна быть больше или равна {value}',
    'show-max-less-then-min': 'Максимальное число показов должно быть больше {value}',
    'show-max-less-then-show-min': 'Максимальное число показов должно быть больше или равно минимальному',
    'show-min-less-then-min': 'Минимальное число показов должно быть больше {value}',
    'tracker-url-cannot-be-empty': 'Не указана ссылка на пакет',
    'tracker-url-invalid': 'Невалидный url',
    'try-later': 'При сохранении возникла ошибка. Попробуйте ещё раз.'
};
